import React from 'react';
import SbEditable from 'storyblok-react';

type Props = {
  blok: Quote;
};

const QuoteBlok: React.FC<Props> = ({ blok }) => {
  return (
    <div className="grid-section pb-4 md:pb-6">
      <div className="hidden md:col-span-3 md:block" />
      {/* @ts-expect-error require storyblok-react upgrade */}
      <SbEditable content={blok}>
        <div className="col-span-12 md:col-span-6">
          <q className="quote w-full text-md">{blok.text}</q>
          {blok.author.length > 0 && (
            <span className="inline-block w-full text-xs text-neutral-4">
              {blok.author}
            </span>
          )}
        </div>
      </SbEditable>
      <div className="hidden md:col-span-3 md:block" />
    </div>
  );
};

export default QuoteBlok;
